import React from 'react'
import { useRouter } from 'next/navigation'
import { useModal } from '@/blocks/redesign_blocks/Modal/ModalContext'
import styles from './styles.module.css'
import AnimatedSection from '@/components/AnimatedSection'

const Services: React.FC = () => {
  const router = useRouter()
  const { openServiceModal } = useModal()

  const handleServiceClick = (serviceId: number) => {
    if (serviceId === 1) {
      // Первая карточка - редирект на страницу разработки
      router.push('/services/development')
    } else if (serviceId === 2) {
      // Карточка "Техническое сопровождение" - редирект на страницу support
      router.push('/services/support')
    } else if (serviceId === 3) {
	  // Карточка "Аутстаффинг" - переход на страницу outstaffing
	  router.push('/services/outstaffing')
    } else {
      // Остальные карточки - открытие модалки сервиса
      openServiceModal()
    }
  }
  const services = [
    {
      id: 1,
      title: 'Заказная разработка',
      description: 'Создаем уникальные цифровые решения или адаптируем готовые под потребности вашего бизнеса. Разрабатываем сайты и приложения, интегрируем системы и модули',
      illustration: 'development'
    },
    {
      id: 2,
      title: 'Техническое сопровождение',
      description: 'Поддерживаем стабильную работу ваших ИТ-систем 24/7. Развиваем функционал, защищаем от угроз и оперативно решаем технические задачи.',
      illustration: 'support'
    },
    {
      id: 3,
      title: 'Аутстаффинг ИТ‑специалистов',
      description: 'Предоставляем выделенных специалистов или целые команды. Это позволяет быстро расти и закрывать кадровые потребности без затрат на долгий поиск и найм.',
      illustration: 'outsourcing'
    }
  ]

  return (
    <section className={styles.services}>
      <div className={styles.container}>
        {/* Block heading */}
        <div className={styles.heading}>
          <div className={styles.subtitle}>
            <p className={styles.subtitleText}>
              Наши услуги
            </p>
          </div>
          <div className={styles.title}>
            <h2 className={styles.titleText}>
              Решения для вашего бизнеса
            </h2>
          </div>
        </div>
        
        {/* Service cards */}
        <div className={styles.grid}>
          {services.map((service) => (
            <div 
              key={service.id} 
              className={styles.card}
            >
              {/* Service illustration */}
              <div className={styles.illustration}>
                {service.illustration === 'development' && (
                  <ServiceIllustration1 />
                )}
                {service.illustration === 'support' && (
                  <ServiceIllustration2 />
                )}
                {service.illustration === 'outsourcing' && (
                  <ServiceIllustration3 />
                )}
              </div>
              
              {/* Service content */}
              <div className={styles.content}>
              <AnimatedSection
                animation="slideLeft"
                delay={100}
                duration={1500}
                distance={20}
                className={styles.content}
              >
                <div className={styles.cardTitle}>
                  <h3 className={styles.cardTitleText}>{service.title}</h3>
                </div>
                <div className={styles.cardDescription}>
                  <p className={styles.cardDescriptionText}>{service.description}</p>
                </div>
                <div className={styles.cardLink}>
                  <div className={styles.linkContent} onClick={() => handleServiceClick(service.id)}>
                    <span className={styles.linkText}>Подробнее</span>
                    <div className={styles.linkIcon}>
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M6.33333 3V4.33333H10.7267L3 12.06L3.94 13L11.6667 5.27333V9.66667H13V3H6.33333Z" fill="#f23b67" />
                      </svg>
                    </div>
                  </div>
                </div>
              </AnimatedSection>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

// Service illustrations as separate components
function ServiceIllustration1() {
  return (
    <div className={styles.illustrationContent}>
      <svg className={styles.illustrationSvg} viewBox="0 0 310 120" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_1233_7525)">
          <g clipPath="url(#clipLinesContainer)">
            <g>
              <g>
                <path d="M0 119H128.311" stroke="white" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M145.762 119H199.139" stroke="#F23B67" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M216.589 119H293.973" stroke="#595959" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
              </g>
              <g transform="translate(-306.987 0)">
                <path d="M0 119H128.311" stroke="white" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M145.762 119H199.139" stroke="#F23B67" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M216.589 119H293.973" stroke="#595959" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
              </g>
              <animateTransform attributeName="transform" type="translate" from="0 0" to="306.987 0" dur="15s" repeatCount="indefinite" />
            </g>
          </g>
          <g clipPath="url(#clipLinesContainerWide)">
            <g>
              <g>
                <path d="M0 15.0001H136.523" stroke="white" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
              </g>
              <g transform="translate(-156.987 0)">
                <path d="M0 15.0001H136.523" stroke="white" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
              </g>
              <animateTransform attributeName="transform" type="translate" from="0 0" to="156.987 0" dur="5s" repeatCount="indefinite" />
            </g>
          </g>
          <g clipPath="url(#clipLinesContainer)">
            <g>
              <g>
                <path d="M145.762 67.0001H282.285" stroke="white" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M0 67.0001H127.285" stroke="#595959" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
              </g>
              <g transform="translate(-306.987 0)">
                <path d="M145.762 67.0001H282.285" stroke="white" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M0 67.0001H127.285" stroke="#595959" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
              </g>
              <animateTransform attributeName="transform" type="translate" from="0 0" to="306.987 0" dur="12s" repeatCount="indefinite" />
            </g>
          </g>
          <g clipPath="url(#clipLinesContainer)">
            <g>
              <g>
                <path d="M0 94.0001H159.794M178.732 94.0001H247.384" stroke="white" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M265.861 94.0001H300" stroke="#F23B67" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
              </g>
              <g transform="translate(310 0)">
                <path d="M0 94.0001H159.794M178.732 94.0001H247.384" stroke="white" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M265.861 94.0001H300" stroke="#F23B67" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
              </g>
              <animateTransform attributeName="transform" type="translate" from="0 0" to="-310 0" dur="8s" repeatCount="indefinite" />
            </g>
          </g>
          <g clipPath="url(#clipLinesContainer)">
            <g>
              <g>
                <path d="M0 40.0001H119.652M133.747 40.0001H231.987" stroke="#F23B67" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M246.358 40.0001H293.974" stroke="#595959" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
              </g>
              <g transform="translate(306.987 0)">
                <path d="M0 40.0001H119.652M133.747 40.0001H231.987" stroke="#F23B67" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M246.358 40.0001H293.974" stroke="#595959" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
              </g>
              <animateTransform attributeName="transform" type="translate" from="0 0" to="-306.987 0" dur="14s" repeatCount="indefinite" />
            </g>
          </g>
          <path d="M277.152 8.11038L285.231 3.16568V4.59322L278.423 8.64771V8.68884L285.231 12.7447V14.1722L277.152 9.2275V8.11038Z" fill="white"/>
          <path d="M290.059 15.0001L294.916 6.10352e-05H296.101L291.225 15.0001H290.059Z" fill="white"/>
          <path d="M308.974 9.2474L300.895 14.1722V12.7447L307.756 8.68884V8.64771L300.895 4.59322V3.16568L308.974 8.09048V9.2474Z" fill="white"/>
          <path d="M277.152 8.11038L285.231 3.16568V4.59322L278.423 8.64771V8.68884L285.231 12.7447V14.1722L277.152 9.2275V8.11038Z" stroke="white" strokeMiterlimit="10"/>
          <path d="M290.059 15.0001L294.916 6.10352e-05H296.101L291.225 15.0001H290.059Z" stroke="white" strokeMiterlimit="10"/>
          <path d="M308.974 9.2474L300.895 14.1722V12.7447L307.756 8.68884V8.64771L300.895 4.59322V3.16568L308.974 8.09048V9.2474Z" stroke="white" strokeMiterlimit="10"/>
        </g>
        <defs>
          <clipPath id="clipLinesContainerWide">
            <rect x="0" y="0" width="156.987" height="120" fill="white"/>
          </clipPath>
          <clipPath id="clipLinesContainer">
            <rect x="0" y="0" width="306.987" height="120" fill="white"/>
          </clipPath>
          <clipPath id="clip0_1233_7525">
            <rect width="310" height="120" fill="white"/>
          </clipPath>
        </defs>
      </svg>
    </div>
  )
}

function ServiceIllustration2() {
  return (
    <div className={styles.illustrationContent}>
      <svg className={styles.illustrationSvg} viewBox="0 0 310 120" fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <path
          id="motionLeft"
          d="
            M87 75
            L81.5737 91.2958
            C79.6454 98.2142 73.3433 103 66.1612 103
            H40
            L39.5 100.5
            A19 19 0 1 0 1.5 100.5
            A19 19 0 1 0 39.5 100.5
            L40 103
            H66.1612
            C73.3433 103 79.6454 98.2142 81.5737 91.2958
            L86.7556 72.7042
            C88.6839 65.7858 94.986 61 102.168 61
            H122
            L123 58
            A32 32 0 0 1 187 58
            L186 61
            C213.056 61 219.335 65.737 221.296 72.6072
            L226.374 90.3928
            C228.336 97.263 234.615 102 241.76 102
            H268
            L268.5 100.5
            A19 19 0 1 0 306.5 100.5
            A19 19 0 1 0 268.5 100.5
            L268 102
            H241.76
            C234.615 102 228.336 97.263 226.374 90.3928
            L221.296 72.6072
            C219.335 65.737 213.056 61 205.911 61
            H186
            L187 58
            A32 32 0 0 0 123 58
            L122 60
            C94.986 60 88.6839 55.2142 86.7556 48.2958
            L81.5737 29.7042
            C79.6454 22.7858 73.3433 18 66.1612 18
            H40
            L39.5 19.5
            A19 19 0 1 0 1.5 19.5
            A19 19 0 1 0 39.5 19.5
            L40 18
            H66.1612
            C73.3433 18 79.6454 22.7858 81.5737 29.7042
            L86.7556 48.2958
            C88.6839 55.2142 94.986 60 102.168 60
            H122
            L123 58
            A32 32 0 0 1 187 58
            L186 60
            C213.056 60 219.335 55.263 221.296 48.3928
            L226.374 30.6072
            C228.336 23.737 234.615 19 241.76 19
            H268
            L268.5 19.5
            A19 19 0 1 0 306.5 19.5
            A19 19 0 1 0 268.5 19.5
            L268 19
            H241.76
            C234.615 19 228.336 23.737 226.374 30.6072
            L221.296 48.3928
            C219.335 55.263 213.056 60 205.911 60
            H186
            L187 58
            A32 32 0 0 0 123 58
            L122 61
            C94.986 61 88.6839 65.7858 87 75
          "
          fill="none"
          stroke="none"
        />

        <path
          id="motionRight"
          d="
            M259.5 18.5
            L268.5 19.5
            A19 19 0 1 1 306.5 19.5
            A19 19 0 1 1 268.5 19.5
            L268 19
            H241.76
            C234.615 19 228.336 23.737 226.374 30.6072
            L221.296 48.3928
            C219.335 55.263 213.056 60 205.911 60
            H186
            L187 58
            A32 32 0 0 1 123 58
            L122 61
            C94.986 61 88.6839 65.7858 86.7556 72.7042
            L81.5737 91.2958
            C79.6454 98.2142 73.3433 103 66.1612 103
            H40
            L39.5 100.5
            A19 19 0 1 1 1.5 100.5
            A19 19 0 1 1 39.5 100.5
            L40 103
            H66.1612
            C73.3433 103 79.6454 98.2142 81.5737 91.2958
            L86.7556 72.7042
            C88.6839 65.7858 94.986 61 102.168 61
            H122
            L123 58
            A32 32 0 0 0 187 58
            L186 61
            C213.056 61 219.335 65.737 221.296 72.6072
            L226.374 90.3928
            C228.336 97.263 234.615 102 241.76 102
            H268
            L268.5 100.5
            A19 19 0 1 1 306.5 100.5
            A19 19 0 1 1 268.5 100.5
            L268 102
            H241.76
            C234.615 102 228.336 97.263 226.374 90.3928
            L221.296 72.6072
            C219.335 65.737 213.056 61 205.911 61
            H186
            L187 58
            A32 32 0 0 1 123 58
            L122 60
            C94.986 60 88.6839 55.2142 86.7556 48.2958
            L81.5737 29.7042
            C79.6454 22.7858 73.3433 18 66.1612 18
            H40
            L39.5 19.5
            A19 19 0 1 1 1.5 19.5
            A19 19 0 1 1 39.5 19.5
            L40 18
            H66.1612
            C73.3433 18 79.6454 22.7858 81.5737 29.7042
            L86.7556 48.2958
            C88.6839 55.2142 94.986 60 102.168 60
            H122
            L123 58
            A32 32 0 0 0 187 58
            L186 60
            C213.056 60 219.335 55.263 221.296 48.3928
            L226.374 30.6072
            C228.336 23.737 234.615 19 241.76 19
            L259.5 18.5
          "
          fill="none"
          stroke="none"
        />
      </defs>
        <mask id="path-1-inside-1_1233_11751" fill="white">
          <path d="M4 0H55V120H4V0Z"/>
        </mask>
        <path d="M55 0H54V120H55H56V0H55ZM4 120H5V0H4H3V120H4Z" fill="#2F2F2F" mask="url(#path-1-inside-1_1233_11751)"/>
        <mask id="path-3-inside-2_1233_11751" fill="white">
          <path d="M54 0H105V120H54V0Z"/>
        </mask>
        <path d="M105 0H104V120H105H106V0H105ZM54 120H55V0H54H53V120H54Z" fill="#2F2F2F" mask="url(#path-3-inside-2_1233_11751)"/>
        <mask id="path-5-inside-3_1233_11751" fill="white">
          <path d="M104 0H156V120H104V0Z"/>
        </mask>
        <path d="M156 0H155V120H156H157V0H156ZM104 120H105V0H104H103V120H104Z" fill="#2F2F2F" mask="url(#path-5-inside-3_1233_11751)"/>
        <mask id="path-7-inside-4_1233_11751" fill="white">
          <path d="M155 0H205V120H155V0Z"/>
        </mask>
        <path d="M205 0H204V120H205H206V0H205ZM155 120H156V0H155H154V120H155Z" fill="#2F2F2F" mask="url(#path-7-inside-4_1233_11751)"/>
        <mask id="path-9-inside-5_1233_11751" fill="white">
          <path d="M204 0H255V120H204V0Z"/>
        </mask>
        <path d="M255 0H254V120H255H256V0H255ZM204 120H205V0H204H203V120H204Z" fill="#2F2F2F" mask="url(#path-9-inside-5_1233_11751)"/>
        <mask id="path-11-inside-6_1233_11751" fill="white">
          <path d="M254 0H305V120H254V0Z"/>
        </mask>
        <path d="M305 0H304V120H305H306V0H305ZM254 120H255V0H254H253V120H254Z" fill="#2F2F2F" mask="url(#path-11-inside-6_1233_11751)"/>
        <circle cx="20.5" cy="19.5" r="19" stroke="#7A7A7A"/>
        <circle cx="20.5" cy="100.5" r="19" stroke="#7A7A7A"/>
        <circle cx="287.5" cy="19.5" r="19" stroke="#7A7A7A"/>
        <circle cx="287.5" cy="100.5" r="19" stroke="#7A7A7A"/>
        <path d="M40 18H66.1612C73.3433 18 79.6454 22.7858 81.5737 29.7042L86.7556 48.2958C88.6839 55.2142 94.986 60 102.168 60H122" stroke="#7A7A7A"/>
        <path d="M40 103H66.1612C73.3433 103 79.6454 98.2142 81.5737 91.2958L86.7556 72.7042C88.6839 65.7858 94.986 61 102.168 61H122" stroke="#7A7A7A"/>
        <path d="M268 19H241.76C234.615 19 228.336 23.737 226.374 30.6072L221.296 48.3928C219.335 55.263 213.056 60 205.911 60H186" stroke="#7A7A7A"/>
        <path d="M268 102H241.76C234.615 102 228.336 97.263 226.374 90.3928L221.296 72.6072C219.335 65.737 213.056 61 205.911 61H186" stroke="#7A7A7A"/>
        <circle cx="155" cy="58" r="32" stroke="#F23B67" strokeWidth="2"/>
        <circle r="4" fill="white">
        <animateMotion dur="25s" repeatCount="indefinite">
          <mpath href="#motionLeft" />
        </animateMotion>
        </circle>

        <circle r="4" fill="white">
        <animateMotion dur="25s" repeatCount="indefinite">
          <mpath href="#motionRight" />
        </animateMotion>
        </circle>
      </svg>
    </div>
  )
}

function ServiceIllustration3() {
  return (
    <div className={styles.illustrationContent}>
      <svg className={styles.illustrationSvg} viewBox="0 0 310 120" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_1233_9428)">
          <path d="M195.293 19V97" stroke="#F23B67" strokeWidth="1.5"/>
          <path d="M114.635 19V97" stroke="#F23B67" strokeWidth="1.5"/>
          <path d="M154.364 58.9999L-3.20 0.15" stroke="#595959"/>
          <path d="M154.364 58.9995L-21.28 28.56" stroke="#595959"/>
          <path d="M154.364 59.0004L-24.98 58.9996" stroke="#595959"/>
          <path d="M-31.8887 91.2883L154.364 59.0005L-16.9735 123" stroke="#595959"/>
          <path d="M155.137 58.9999L322.068 -3.35383" stroke="#595959"/>
          <path d="M155.136 58.9995L340.616 26.8455" stroke="#595959"/>
          <path d="M155.136 59.0004L344.48 58.9995" stroke="#595959"/>
          <path d="M341.389 91.2883L155.136 59.0005L326.474 123" stroke="#595959"/>
          <path d="M114.83 19.5598L91.1702 3.78662V113.213L114.83 96.4543" stroke="#F23B67" strokeWidth="1.5"/>
          <path d="M194.957 19.5598L218.617 3.78662V113.213L194.957 96.4543" stroke="#F23B67" strokeWidth="1.5"/>
          <circle r="2.82019" fill="white">
            <animateMotion dur="12s" repeatCount="indefinite">
              <mpath href="#motionLeftTop" />
            </animateMotion>
          </circle>
          <circle r="2.67517" fill="white">
            <animateMotion dur="12s" repeatCount="indefinite">
              <mpath href="#motionRightLower" />
            </animateMotion>
          </circle>
          <circle r="2.67517" fill="white">
            <animateMotion dur="12s" repeatCount="indefinite">
              <mpath href="#motionRightTop" />
            </animateMotion>
          </circle>
          <circle r="2.67517" fill="white">
            <animateMotion dur="12s" repeatCount="indefinite">
              <mpath href="#motionLeftMiddle" />
            </animateMotion>
          </circle>
          <path d="M149.542 56.7014L154.606 58.5508L159.362 56.8877L158.67 60.8694L154.797 59.4368L150.312 61.0176L149.542 56.7014Z" fill="#595959"/>
        </g>
        <defs>
          <path
            id="motionRightLower"
            d="
              M186.072 70.4613
              L309.474 116
              L155.136 59.0004
              L310.389 86.2883
              L155.136 59.0005
              L308.48 58.9995
              L155.136 59.0005
              L186.072 70.4613
            "
            fill="none"
            stroke="none"
          />
          <path
            id="motionRightTop"
            d="
              M300.261 33.7003
              L155.136 59.0004
              L308.48 58.9995
              L155.136 59.0004
              L312.068 -0.5
              L155.136 59.0004
              L300.261 33.7003
              L312.261 33.7003
              L300.261 33.7003
            "
            fill="none"
            stroke="none"
          />
          <path
            id="motionLeftMiddle"
            d="
              M64.299 58.5
              L154.364 59.0005
              L-0 86.2883
              L154.364 59.0005
              L-0 115
              L154.364 59.0005
              L0 59.0005
              L64.299 59.0005
              L64.299 59.0005
            "
            fill="none"
            stroke="none"
          />
          <path
            id="motionLeftTop"
            d="
              M22.6759 9.27832
              L154.364 58.9999
              L-0.5 31.56
              L154.364 58.9995
              L-0.5 58.9996
              L154.364 59.0004
              L-0.20 1.15
              L22.6759 9.27832
            "
            fill="none"
            stroke="none"
          />
          <clipPath id="clip0_1233_9428">
            <rect width="310" height="120" fill="white"/>
          </clipPath>
        </defs>
      </svg>
    </div>
  )
}

Services.displayName = 'Services'

export default Services